module.exports = __webpack_public_path__ + "img/cartaz.12c6610d.jpg";